import { render, staticRenderFns } from "./fangpian.vue?vue&type=template&id=54ae451e"
import script from "./fangpian.vue?vue&type=script&lang=js"
export * from "./fangpian.vue?vue&type=script&lang=js"
import style0 from "./fangpian.vue?vue&type=style&index=0&id=54ae451e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports